import { IosShare } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import React from "react";

import { SectionHeader } from "@/components/common/SectionHeader";

interface StoreInsightsPanelProps {
  title: React.ReactNode;
  onExport?: () => void;
  exportDisabled?: boolean;
  headerActions?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export const StoreInsightsPanel: React.FC<StoreInsightsPanelProps> = ({
  title,
  onExport,
  exportDisabled = false,
  headerActions,
  footer,
  children,
}) => {
  const showHeader = Boolean(title) || Boolean(onExport);

  return (
    <Box
      className="bg-white rounded-2xl border border-blue-50 shadow-md shadow-blue-100 mt-4 w-full flex flex-col"
      sx={{ p: { xs: 2, md: 3 }, minWidth: 0 }}
    >
      {showHeader ? (
        <SectionHeader
          title={title}
          actions={headerActions}
          trailing={
            onExport ? (
              <IconButton size="small" onClick={onExport} disabled={exportDisabled}>
                <IosShare
                  fontSize="small"
                  className={exportDisabled ? "text-gray-300" : "text-blue-500"}
                />
              </IconButton>
            ) : null
          }
        />
      ) : null}
      <div className="overflow-x-auto flex-1 min-w-0">{children}</div>
      {footer}
    </Box>
  );
};
